// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Colors
 */
/**
 * Paddings, margins.
 */
/**
 *  Images
 */
/**
 * Fonts.
 */
/**
 * Mixins.
 */
.animate {
  -webkit-transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);
  transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);
}
@-webkit-keyframes pulsate {
  0% {
    -webkit-transform: scale(0.8, 0.8);
            transform: scale(0.8, 0.8);
    opacity: 0.5;
  }
  50% {
    -webkit-transform: scale(1.2, 1.2);
            transform: scale(1.2, 1.2);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0.8, 0.8);
            transform: scale(0.8, 0.8);
    opacity: 0.5;
  }
}
.content__index-top {
  text-align: center;
}
.dashboard-example-wrapper {
  margin-top: 50px;
  padding-bottom: 20px;
}
.dashboard-example-wrapper h3 {
  letter-spacing: 0.7px;
  font-weight: bold;
}
.dashboard-example-image {
  padding: 20px;
  border: 2px solid #d9d9d9;
  box-shadow: 4px 1px 8px 1px #a6a6a6;
  -webkit-box-shadow: 4px 1px 8px 1px #a6a6a6;
  -moz-box-shadow: 4px 1px 8px 1px #a6a6a6;
}
.content__index-dashboard {
  background-color: #ffffff;
  text-align: center;
  padding: 0 !important;
}
.content__index-dashboard > div {
  display: inline-block;
  position: relative;
}
.content__index-dashboard > div > img {
  max-width: 100%;
  display: block;
}
.content__index-dashboard > div > i {
  display: none;
  -webkit-transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);
  transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);
  -webkit-animation: pulsate 1.5s ease-out;
          animation: pulsate 1.5s ease-out;
  -webkit-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 20px;
  color: #ffffff;
  padding: 4px 8px 4px 7px;
  position: absolute;
}
.content__index-dashboard > div > i:hover {
  background-color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  -webkit-animation-play-state: paused;
          animation-play-state: paused;
}
.content__index-dashboard > div > i.annotation-settings {
  top: 25px;
  left: 450px;
}
.content__index-dashboard > div > i.annotation-filters {
  top: 450px;
  left: 200px;
}
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .content__index-dashboard > div > i.annotation-settings {
    top: 10px;
    left: 300px;
  }
  .content__index-dashboard > div > i.annotation-filters {
    top: 300px;
    left: 150px;
  }
}
/**
 * Overrides.
 */
._720kb-tooltip._720kb-tooltip-medium {
  max-width: 400px;
}
`, "",{"version":3,"sources":["webpack://./src/feature/index/index.less","webpack://./src/less/variables.less","webpack://./src/less/mixins.less"],"names":[],"mappings":"AAAA;;EAEE;AACF;;EAEE;AACF;;EAEE;AACF;;EAEE;AACF;;EAEE;ACsBF;EACE,4DAAA;EAAA,oDAAA;ADpBF;AEjBA;EACE;IACE,kCAAA;YAAA,0BAAA;IACA,YAAA;EFmBF;EEhBA;IACE,kCAAA;YAAA,0BAAA;IACA,UAAA;EFkBF;EEfA;IACE,kCAAA;YAAA,0BAAA;IACA,YAAA;EFiBF;AACF;AAzBA;EACE,kBAAA;AA2BF;AAxBA;EACE,gBAAA;EACA,oBAAA;AA0BF;AA5BA;EAKI,qBAAA;EACA,iBAAA;AA0BJ;AAtBA;EACE,aAAA;EACA,yBAAA;EEJA,mCAAA;EACA,2CAAA;EACA,wCAAA;AF6BF;AAtBA;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;AAwBF;AAvBE;EACE,qBAAA;EACA,kBAAA;AAyBJ;AAvBI;EACE,eAAA;EACA,cAAA;AAyBN;AAtBI;EACE,aAAA;ECJJ,4DAAA;EAAA,oDAAA;EDMI,wCAAA;UAAA,gCAAA;EACA,2CAAA;UAAA,mCAAA;EACA,oCAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;AAwBN;AAtBM;EACE,oCAAA;EACA,eAAA;EACA,oCAAA;UAAA,4BAAA;AAwBR;AArBM;EAAwB,SAAA;EAAW,WAAA;AAyBzC;AAxBM;EAAuB,UAAA;EAAY,WAAA;AA4BzC;AA1BM;EAGI;IAAwB,SAAA;IAAW,WAAA;EA4B3C;EA3BQ;IAAuB,UAAA;IAAY,WAAA;EA+B3C;AACF;AACA;;EAEE;AA3BF;EAAwC,gBAAA;AA8BxC","sourcesContent":["@import '../../less/variables';\n@import '../../less/mixins';\n\n@hotspot-bg: rgba(0, 0, 0, 0.4);\n@hotspot-hover-bg: rgba(0, 0, 0, 0.6);\n\n.content__index-top {\n  text-align: center;\n}\n\n.dashboard-example-wrapper {\n  margin-top: 50px;\n  padding-bottom: 20px;\n\n  h3 {\n    letter-spacing: 0.7px;\n    font-weight: bold;\n  }\n}\n\n.dashboard-example-image {\n  padding: 20px;\n  border: 2px solid #d9d9d9;\n  .box-shadow(4px, 1px, 8px, 1px, #a6a6a6);\n\n}\n\n.content__index-dashboard {\n  background-color: @white;\n  text-align: center;\n  padding: 0 !important;\n  & > div {\n    display: inline-block;\n    position: relative;\n\n    & > img {\n      max-width: 100%;\n      display: block;\n    }\n\n    & > i {\n      display: none;\n      .animate();\n      animation: pulsate 1.5s ease-out;\n      animation-iteration-count: infinite;\n      background-color: @hotspot-bg;\n      border-radius: 20px;\n      color: @white;\n      padding: 4px 8px 4px 7px;\n      position: absolute;\n\n      &:hover {\n        background-color: @hotspot-hover-bg;\n        cursor: pointer;\n        animation-play-state: paused;\n      }\n\n      &.annotation-settings { top: 25px; left: 450px; }\n      &.annotation-filters { top: 450px; left: 200px; }\n\n      @media\n        (-webkit-min-device-pixel-ratio: 2),\n        (min-resolution: 192dpi) {\n          &.annotation-settings { top: 10px; left: 300px; }\n          &.annotation-filters { top: 300px; left: 150px; }\n      }\n    }\n  }\n}\n/**\n * Overrides.\n */\n._720kb-tooltip._720kb-tooltip-medium { max-width: 400px; }\n","/**\n * Colors\n */\n@black: rgb(0, 0, 0);\n@blue: rgb(7, 191, 234);\n@cream: rgb(250, 250, 250);\n@gray-dark: rgb(165, 163, 166);\n@gray: rgb(230, 230, 230);\n@gray-outline: rgb(217, 217, 217);\n@green-dark: rgb(63, 136, 41);\n@green: rgb(76, 169, 47);\n@white: rgb(255, 255, 255);\n@error: rgb(255, 0, 0);\n\n/**\n * Paddings, margins.\n */\n@padding-content: 5px;\n@padding-btn: 10px;\n@padding-navi-link: 10px;\n@margin-btn: 10px;\n@margin-base: 10px;\n\n/**\n *  Images\n */\n@img-size-upload: 150px;\n\n/**\n * Fonts.\n */\n@font-size-base: 1.6em;\n\n/**\n * Mixins.\n */\n.animate {\n  transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);\n}\n","@-webkit-keyframes pulsate {\n  0% {\n    transform: scale(0.8, 0.8);\n    opacity: 0.5;\n  }\n\n  50% {\n    transform: scale(1.2, 1.2);\n    opacity: 1.0;\n  }\n\n  100% {\n    transform: scale(0.8, 0.8);\n    opacity: 0.5;\n  }\n}\n\n.box-shadow (@offset-x: 1px, @offset-y: 10px, @blur-radius: 2px, @spread-radius: 1px, @color: #000000) {\n  box-shadow: @offset-x @offset-y @blur-radius @spread-radius @color;\n  -webkit-box-shadow: @offset-x @offset-y @blur-radius @spread-radius @color;\n  -moz-box-shadow: @offset-x @offset-y @blur-radius @spread-radius @color;\n}\n\n.border-radius (@radius)  {\n  -webkit-border-radius: @radius;\n  -moz-border-radius: @radius;\n  border-radius: @radius;  \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
